import { render } from "./YearlyProfit.vue?vue&type=template&id=8c6e8ce8&scoped=true&ts=true"
import script from "./YearlyProfit.vue?vue&type=script&lang=ts"
export * from "./YearlyProfit.vue?vue&type=script&lang=ts"

import "./YearlyProfit.vue?vue&type=style&index=0&id=8c6e8ce8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2602801780/src/biomass-frontend-poc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c6e8ce8"]])

export default __exports__